import React, { useEffect, useState } from "react";
import { Box, Select, MenuItem } from "@mui/material";
import { LANGUAGES } from "../../../utilities/constants";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../../store/actions/language";
import "./index.scss";

function SelectLanguage() {
  const dispatch = useDispatch();
  const { data: language } = useSelector((state) => state.language);
  const systemLanguage = language || localStorage.getItem("language", language) || "en";
  return (
    <div>
      <Box>
        <Select
          value={systemLanguage}
          onChange={(e) => {
            dispatch(setLanguage(e.target.value));
          }}
          size="small"
          displayEmpty
        >
          {LANGUAGES.map((lang) => (
            <MenuItem key={lang.key} value={lang.value}>
              {lang.text}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </div>
  );
}
export default SelectLanguage;
